// third-party
import { FormattedMessage } from 'react-intl';

// assets

import { DashboardCustomizeOutlined } from '@mui/icons-material';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import enums from 'utils/enums';
// icons
const icons = {
  DashboardCustomizeOutlined,
  AnalyticsOutlinedIcon
};

// ==============================|| MENU ITEMS - MAIN ||============================== //

const dashboard = {
  id: 'dashboard',
  type: 'group',
  title: <FormattedMessage id='dashboard' />,
  roleTags: [enums.userRole.SuperAdmin, enums.userRole.CJAdmin, enums.userRole.SiteManager, enums.userRole.User],
  children: [
    {
      id: 'dashboard',
      title: <FormattedMessage id='dashboard' />,
      type: 'item',
      url: 'dashboard/analytics',
      icon: icons.AnalyticsOutlinedIcon,
      roleTags: [enums.userRole.SuperAdmin, enums.userRole.CJAdmin, enums.userRole.SiteManager, enums.userRole.User],
      showTitle: false
    },
    {
      id: 'analytics',
      title: <FormattedMessage id='analytics' />,
      subTitle: 'Analytics',
      type: 'item',
      url: 'dashboard/reports',
      icon: icons.DashboardCustomizeOutlined,
      roleTags: [enums.userRole.SuperAdmin, enums.userRole.CJAdmin],
      showTitle: true
    },
  ]
};

export default dashboard;
